export const buttonSubTabs = {
  primaryButtons: 'primaryButtons',
  simpleButtons: 'simpleButtons',
  links: 'links',
}

export const subTabToColorGroup = {
  [buttonSubTabs.primaryButtons]: 'buttonColors',
  [buttonSubTabs.simpleButtons]: 'buttonSimpleColors',
  [buttonSubTabs.links]: 'linkColors',
}

export const previewConfig = {
  [buttonSubTabs.primaryButtons]: {
    activeLabel: 'Esto es un botón primario activo',
    disabledLabel: 'Esto es un botón primario deshabilitado',
    normal: {
      background: 'buttonBackgroundColor',
      border: 'buttonBorderColor',
      text: 'buttonColor',
    },
    hover: {
      background: 'buttonHoverBackgroundColor',
      border: 'buttonHoverBorderColor',
      text: 'buttonHoverColor',
    },
    disabled: {
      background: 'buttonDisabledBackgroundColor',
      border: 'buttonDisabledBorderColor',
      text: 'buttonDisabledColor',
    },
    themeButtonKey: 'primary',
    buttonVariant: 'contained',
  },
  [buttonSubTabs.simpleButtons]: {
    activeLabel: 'Esto es un botón simple activo',
    disabledLabel: 'Esto es un botón simple deshabilitado',
    normal: {
      text: 'buttonSimpleColor',
    },
    hover: {
      text: 'buttonSimpleHoverColor',
    },
    disabled: {
      text: 'buttonSimpleDisabledColor',
    },
    themeButtonKey: 'text',
    buttonVariant: 'text',
  },
  [buttonSubTabs.links]: {
    activeLabel: 'Esto es un enlace',
    disabledLabel: null,
    normal: {
      text: 'linkColor',
    },
    hover: {
      text: 'linkHover',
    },
    disabled: null,
    isLink: true,
    alertLabel: 'Para ver el estilo hover coloca el cursor sobre el enlace',
  },
}
